import React, { Component } from 'react'
import { Popconfirm, message, Divider,  Table, Form, Icon, Input, Button } from 'antd'
import { Route, Link } from 'react-router-dom';

import client from '../../feathers'
import requireAuth  from "../../components/requireAuth"
import Layout  from "../../components/layout"
import MngpropertiesForm  from "../../components/mngproperties/form"

import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import {
  fetchMngproperties,
  pushMngproperties,
  removeMngproperties,
  updateMode,
  updateActiveMngproperties,
  updateMngproperties } from '../../actions/actions-mngproperties'

const FormItem = Form.Item;

const text = 'Are you sure to delete this item?';

class MngpropertiesIndex extends Component {
  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidUpdate(){
  }

  componentDidMount(){
      client.service('mngproperties').on('created', (mngproperties) => {
        this.props.pushMngproperties(mngproperties)
      })

      client.service('mngproperties').on('removed', (mngproperties) => {
        this.props.removeMngproperties(mngproperties)
      })

      client.service('mngproperties').on('updated', (mngproperties) => {
        this.props.updateMngproperties(mngproperties)
      })
  }

  componentWillMount(){
      client.authenticate()
      .then(()=>{
          return client.service('mngproperties').find({
            query: {
               $sort: {
                 createdAt: -1
               }
             }
          })
      })
      .then((res)=>{
        this.props.fetchMngproperties(res.data)
      })
      .catch((err)=>{
          console.log(err);
      })
  }

  handleDelete(_id) {
     client.service('mngproperties').remove(_id)
     .then((res)=>{
     })
     .catch((err)=>{
       alert(err);
     })
  }

  handleEdit(_id) {
    this.props.updateActiveMngproperties('edit',_id)
  }

  handleManage(_id) {
    this.props.updateActiveMngproperties('',_id)
  }

  showModal = () => {
    this.props.updateMode('new')
  }

  renderConfirmDeleteBtn(_id){
    return (
      <Popconfirm placement="topLeft" title={text} onConfirm={()=>this.handleDelete(_id)} okText="Confirm" cancelText="Cancel">
        <Button type="danger">Delete</Button>
      </Popconfirm>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const columns = [{
        title: 'User',
        dataIndex: 'userId',
        key: 'userId',
      },
      {
        title: 'Management',
        dataIndex: 'managementId',
        key: 'managementId',
      },
      {
        title: 'Property',
        dataIndex: 'propertyId',
        key: 'propertyId',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Divider type="vertical" />
          <Button onClick={()=>this.handleEdit(record._id)}>Edit</Button>
          <Divider type="vertical" />
          {this.renderConfirmDeleteBtn(record._id)}
        </span>
      ),
    }];

    return(
      <Layout>
        <Button type="primary" onClick={this.showModal}>New Assignment</Button>

        <Table dataSource={this.props.mngproperties.mngproperties} columns={columns} rowKey="_id" />
        <MngpropertiesForm />

      </Layout>
    )
  }
}


function mapStateToProps(state) {
  return {
    mngproperties: state.mngproperties,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchMngproperties: fetchMngproperties,
    pushMngproperties: pushMngproperties,
    removeMngproperties: removeMngproperties,
    updateActiveMngproperties: updateActiveMngproperties,
    updateMngproperties: updateMngproperties,
    updateMode: updateMode
    }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(MngpropertiesIndex)));
